import type { StateCreator } from 'zustand';
import type { SliceMutators } from '~/store/mutators';

export type SourceSlice = {
  source: {
    fileName: string | null;
    dimensions: { w: number; h: number } | null;
    imageData: ImageData | null;
    hash: string | null;
    /** Bumps each time pixels are edited in place (e.g. watermark bake). Resets on fresh load. */
    revision: number;
  };
  setSource: (input: { fileName: string; imageData: ImageData; hash: string }) => void;
  bakeSourcePixels: (imageData: ImageData) => void;
  resetSource: () => void;
};

const INITIAL_SOURCE = {
  fileName: null,
  dimensions: null,
  imageData: null,
  hash: null,
  revision: 0,
} satisfies SourceSlice['source'];

export const createSourceSlice: StateCreator<SourceSlice, SliceMutators, [], SourceSlice> = (
  set,
) => ({
  source: INITIAL_SOURCE,
  setSource: (input) =>
    set((s) => {
      s.source.fileName = input.fileName;
      s.source.dimensions = { w: input.imageData.width, h: input.imageData.height };
      s.source.imageData = input.imageData;
      s.source.hash = input.hash;
      s.source.revision = 0;
    }),
  bakeSourcePixels: (imageData) =>
    set((s) => {
      s.source.imageData = imageData;
      s.source.dimensions = { w: imageData.width, h: imageData.height };
      s.source.revision += 1;
    }),
  resetSource: () =>
    set((s) => {
      s.source = { ...INITIAL_SOURCE };
    }),
});
